import _classCallCheck from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/inherits";
import Transformer from "./Transformer";

var FlowTransformer =
/*#__PURE__*/
function (_Transformer) {
  _inherits(FlowTransformer, _Transformer);

  function FlowTransformer(rootTransformer, tokens) {
    var _this;

    _classCallCheck(this, FlowTransformer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FlowTransformer).call(this));
    _this.rootTransformer = rootTransformer;
    _this.tokens = tokens;
    ;
    return _this;
  }

  _createClass(FlowTransformer, [{
    key: "process",
    value: function process() {
      return this.rootTransformer.processPossibleArrowParamEnd() || this.rootTransformer.processPossibleAsyncArrowWithTypeParams() || this.rootTransformer.processPossibleTypeRange();
    }
  }]);

  return FlowTransformer;
}(Transformer);

export { FlowTransformer as default };